<template>
    <div class="filter-popup" v-bind:style="{display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="background" v-on:click="Close()"></div>
        <div class="header">
            <div class="label">Filter Einstellungen</div>
        </div>


                <div style="padding:4px;">
                    <div v-if="parent.showBusinessUnits" class="buBackgroudGreen" v-on:click="ToggleBusinessUnits()">
                        <div style="display:inline-block; width: 30px;"><i class="fas fa-check-circle"></i></div><div style="display:inline-block; padding-left: 10px;">Sortierung nach Stammbereich</div>
                    </div>
                    <div v-if="!parent.showBusinessUnits" class="buBackgroudGray" v-on:click="ToggleBusinessUnits()">
                        <div style="display:inline-block; width: 30px;"><i class="fas fa-ban"></i></div><div style="display:inline-block; padding-left: 10px;">Keine Sortierung nach Stammbereich</div>
                    </div>
                </div>

                <div style="padding:4px;">
                    <div v-if="parent.dynamicFiltering" class="buBackgroudGreen" v-on:click="ToggleDynamicFilter()">
                        <div style="display:inline-block; width: 30px;"><i class="fas fa-check-circle"></i></div><div style="display:inline-block; padding-left: 10px;">Dynamsicher Filter ist aktiviert</div>
                    </div>
                    <div v-if="!parent.dynamicFiltering" class="buBackgroudGray" v-on:click="ToggleDynamicFilter()">
                        <div style="display:inline-block; width: 30px;"><i class="fas fa-ban"></i></div><div style="display:inline-block; padding-left: 10px;">Dynamsicher Filter ist deaktiviert</div>
                    </div>
                </div>


        <div v-if="!parent.dynamicFiltering">
            <hr/>
            <div class="header">
                <div class="label">Filter - Mitarbeiter Fähigkeiten</div>
            </div>


                <div style="padding:4px;" v-for="(spot, id) in parent.spotMap" :key="id">
                    <div v-if="spot.toggled" class="buBackgroudGreen" v-on:click="ToggleSkill($event, spot.requiredSkill, null, id)">
                        <div style="display:inline-block; width: 30px;"><i class="fas fa-check-circle"></i></div><div style="display:inline-block; padding-left: 10px;">{{ spot.name }}</div>
                    </div>
                    <div v-if="!spot.toggled" class="buBackgroudGray" v-on:click="ToggleSkill($event, spot.requiredSkill, null, id)">
                        <div style="display:inline-block; width: 30px;"><i class="fas fa-ban"></i></div><div style="display:inline-block; padding-left: 10px;">{{ spot.name }} &nbsp; <small class="text-muted"><em>({{ spot.employeeCount }} Mitarbeiter)</em></small></div>
                    </div>
                </div>
                <div style="padding:4px;" v-for="(skill, id) in parent.softSkills" :key="id">
                    <div v-if="skill.toggled" class="buBackgroudGreen" v-on:click="ToggleSkill($event, skill.id, id, null)">
                        <div style="display:inline-block; width: 30px;"><i class="fas fa-check-circle"></i></div><div style="display:inline-block; padding-left: 10px;">{{ skill.name }}</div>
                    </div>
                    <div v-if="!skill.toggled" class="buBackgroudGray" v-on:click="ToggleSkill($event, skill.id, id, null)">
                        <div style="display:inline-block; width: 30px;"><i class="fas fa-ban"></i></div><div style="display:inline-block; padding-left: 10px;">{{ skill.name }} &nbsp; <small class="text-muted"><em>({{ skill.employeeCount }} Mitarbeiter)</em></small></div>
                    </div>
                </div>

        </div>

    </div>
</template>


<script>
    export default {
        name: 'filterpopup',
        components: {
        },
        data(){
            return{
                parent: null,
                toggled: false,
                rawData: null,

                softSkillsFiltered: [],


            }
        },
        created () {
            var view = this;
        },
        destroyed(){
        },
        methods: {
            Close(){
                if($(window.mouse.element).closest('.filter-popup').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
            },
            Init(parent){
                this.parent = parent;
                this.toggled = true;
            },
            InitData(){
                var view = this;
            },
            ToggleBusinessUnits(){
                this.parent.showBusinessUnits = !this.parent.showBusinessUnits;
                this.parent.sortEmployeeGroups();
            },
            ToggleDynamicFilter(){
                this.parent.dynamicFiltering = !this.parent.dynamicFiltering;
                this.parent.filterEmployees();
            },
            ToggleSkill($event, skillId, id, idmap){
                if(id != null) this.parent.softSkills[id].toggled = !this.parent.softSkills[id].toggled;
                if(idmap != null) this.parent.spotMap[idmap].toggled = !this.parent.spotMap[idmap].toggled;

                let index = this.parent.softSkillsFiltered.indexOf(skillId);
                if (index !== -1){
                    this.parent.softSkillsFiltered.splice(index, 1);
                }else{
                    this.parent.softSkillsFiltered.push(skillId);
                }
                this.parent.filterEmployees();
                this.$forceUpdate();
            }

        },
        mounted() {
            $('html').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


    .buBackgroudGreen{
        background-color: #6d8d23; 
        padding:4px 10px; 
        border-radius: 20px; 
        color: #fff; 
        cursor:pointer; 
        transition: background-color 500ms linear;
        transition: color 500ms linear;
    }
    .buBackgroudGray{
        background-color: #e5e5e5; 
        padding:4px 10px; 
        border-radius: 20px; 
        color: #555; 
        cursor:pointer; 
        transition: background-color 500ms linear;
        transition: color 500ms linear;
    }

    .filter-popup{
        position:fixed;
        display:inline-block;
        max-height: 520px;
        width: 400px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        border: 1px solid #a5a5a5;
        padding: 30px;

        top: 120px;
        left: 78px;
        overflow-y: auto;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }


    .header{
        margin-bottom:45px;
    }
    .header .label{
        box-shadow: inset 0 -1px 0 0px #ebebeb;
        font-size: 20px;
    }

    .fa-stack.cancel{
        cursor: pointer;
        position: absolute;
        top: 6px;
        right: 5px;
        font-size: 10px;
        transform: scale(.8);
    }
    .fa-stack.cancel .fa-circle{
    }
    .fa-stack.cancel .fa-times{
        font-size: 13px;
        transform: translateY(3px);
    }

</style>
